<template>
  <div class="home" :class="{jp: $region === 'jp', sea: $area === 'komoe-sea'}">
    <div class="banner" v-if="is_show_banner">
      <!-- <div class="banner"> -->
      <!-- <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide swiper-no-swiping"
            v-for="(item, index) in bannerLists"
            :key="index"
            :style="{'background-image': 'url(' + item.image + ')'}"
          >
            <a
              class="bui-btn more-banner"
              :href="item.url"
              target="_blank"
              :ga-data="'10200'+(++index)"
            >
              <span>{{ $t('home.knowmore') }}</span>
              <div></div>
            </a>
          </div>
        </div>
        <div class="swiper-pagination" v-show="bannerLists.length > 1"></div>
        <div class="swiper-button-prev" v-show="bannerLists.length > 1"></div>
        <div class="swiper-button-next" v-show="bannerLists.length > 1"></div>
      </div> -->
      <mswipe :bannerLists="bannerLists" v-if="bannerLists && bannerLists.length > 0"></mswipe>
    </div>
    <div v-if="is_show_recommend" class="recommend">
      <!-- <div class="recommend"> -->
      <p class="bui-title">{{ $t('home.recommendGame') }}</p>
      <p class="bui-title-little" v-if="$area !== 'komoe-sea'">HOT GAMES</p>
      <div class="game-lists">
        <ul v-if="topGameLists">
          <li
            v-for="(item, index) in topGameLists"
            :key="index"
            v-show="index < 4 || !showMoreGame"
          >
            <div class="game-img" :style="{'backgroundImage': 'url(' + item.image + ')'}"></div>
            <p class="game-name">{{item.game_name}}</p>
            <p class="game-description">{{item.summary}}</p>
            <a :href="item.url" target="_blank" :ga-data="'10300'+(++index)"></a>
          </li>
        </ul>
      </div>
      <div
        class="bui-btn"
        v-show="topGameLists.length > 4 && showMoreGame"
        @click="showAllGames()"
        ga-data="103009"
      >
        <span>{{ $t('home.moreGame') }}</span>
        <div></div>
      </div>
    </div>
    <div class="news-notice" v-if="is_show_news_notice">
      <!-- <div class="news-notice"> -->
      <p class="bui-title">{{$t('home.newsNotice')}}</p>
      <p class="bui-title-little">NEWS</p>
      <div class="news-content" v-if="topNews">
        <div class="news-left">
          <div
            class="big-img"
            :style="{'backgroundImage': 'url(' + topNews.top_image_large.image_large + ')'}"
          ></div>
          <div class="title">
            <span class="type">{{ changeType(topNews.top_image_large.type) }}</span>
            <strong>{{ topNews.top_image_large.title }}</strong>
            <span class="time">{{ formateTime(topNews.top_image_large.publish_time) }}</span>
          </div>
          <p>{{ topNews.top_image_large.summary }}</p>
          <!-- :href="topNews.top_image_large.url || '../newsdetail/#' + topNews.top_image_large.news_id" -->
          <a
            @click="toDetail({url:topNews.top_image_large.url, id:topNews.top_image_large.news_id})"
            ga-data="104001"
          ></a>
        </div>
        <div class="news-right">
          <div class="mini-news" v-for="(item, index) in topNews.top_image_small_list" :key="index">
            <div :style="{'backgroundImage': 'url(' + item.image_small + ')'}"></div>
            <p>{{item.title}}</p>
            <div>
              <span class="type">{{ changeType(item.type) }}</span>
              <span class="time">{{ formateTime(item.publish_time) }}</span>
            </div>
            <!-- :href="item.url || '../newsdetail/#' + item.news_id" -->
            <a @click="toDetail({url:item.url, id:item.news_id})" :ga-data="'10400'+(index+2)"></a>
          </div>
          <div class="line" v-for="(item, index) in topNews.top_news_list" :key="'news-'+index">
            <span
              class="type"
              :class="{'hot': item.type == 0 || item.type == 6}"
            >{{ changeType(item.type) }}</span>
            <span class="desc">{{item.title}}</span>
            <span class="icon"></span>
            <!-- :href="item.type == 0 ? './news/' : item.url || '../newsdetail/#' + item.news_id" -->
            <a @click="toDetail({url:item.url, id:item.news_id})" :ga-data="'10400'+(index+4)"></a>
          </div>
        </div>
        <a></a>
      </div>
      <router-link class="bui-btn" :to="{name:'news'}" ga-data="104010">
        <span>{{$t('home.moreNews')}}</span>
        <div></div>
      </router-link>
    </div>
    
    <div v-if="$region !== 'jp' ">
      <div class="active" v-if="is_show_activity">
        <!-- <div class="active"> -->
        <p class="bui-title">{{$t('home.newActive')}}</p>
        <p class="bui-title-little">{{$t('home.newActiveBot')}}</p>
        <div class="activity-container">
          <a
            class="activity-line"
            @click="toActiveDetail({url:item.url, id:item.activity_id})"
            v-for="(item, index) in topEvents"
            :key="index"
            :ga-data="'10500'+(++index)"
          >
            <span>{{ formateTime(item.publish_time) }}</span>
            <span>{{ item.title }}</span>
            <span v-show="item.is_top == 1"></span>
            <span></span>
          </a>
        </div>
        <router-link class="bui-btn more-activity" :to="{name:'active'}" ga-data="105009">
          <span>{{$t('home.moreActive')}}</span>
          <div></div>
        </router-link>
      </div>
    </div>

    <div v-if="$region == 'jp' ">
      <div class="active" v-if="is_show_activity" style="border:none;">
        <!-- <div class="active"> -->
        <p class="bui-title">{{$t('home.newActive')}}</p>
        <p class="bui-title-little">{{$t('home.newActiveBot')}}</p>
        <div class="activity-container">
          <a
            class="activity-line"
            @click="toActiveDetail({url:item.url, id:item.activity_id})"
            v-for="(item, index) in topEvents"
            :key="index"
            :ga-data="'10500'+(++index)"
          >
            <span>{{ formateTime(item.publish_time) }}</span>
            <span>{{ item.title }}</span>
            <span v-show="item.is_top == 1"></span>
            <span></span>
          </a>
        </div>
        <router-link class="bui-btn more-activity" :to="{name:'active'}" ga-data="105009">
          <span>{{$t('home.moreActive')}}</span>
          <div></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
// import Swiper from "swiper";
import mswipe from '@mswipe/mainSwipe.vue';
// import footerBar from "../../component/footer/komoe/index";
// Vue.component('footerBar', function(resolve){
//     require(["../../component/footer/"+this.$+"/index"], resolve);
// });


export default {
  name: "home",
  data() {
    return {
      // is_show_banner	Y	int	是否显示大 banner 模块（0：显示 1：不显示）默认为 1
      // is_show_recommend	Y	int	是否显示推荐游戏模块（0：显示 1：不显示）默认为 0
      // is_show_news_notice	Y	int	是否显示新闻公告模块（0：显示 1：不显示）默认为 0
      // is_show_activity	Y	int	是否显示最新活动模块（0：显示 1：不显示）默认为 0
      is_show_banner: 0,
      is_show_recommend: 0,
      is_show_news_notice: 0,
      is_show_activity: 0,
      name: "",
      bannerLists: [],
      topGameLists: "",
      topNews: null,
      topEvents: "",
      showMoreGame: true
    };
  },
  components: {
    mswipe
  },
  methods: {
    toDetail(param) {
      if (param.url) {
        window.location.href = param.url;
      } else {
        this.$router.push({ name: "newsDetail", params: { id: param.id } });
      }
    },
    toActiveDetail(param) {
      if (param.url) {
        window.location.href = param.url;
      } else {
        this.$router.push({ name: "activeDetail", params: { id: param.id } });
      }
    },
    formateTime(time) {
      let temp = time ? time.split(" ")[0].replace(/-/g, ".") : "";
      return temp;
    },
    changeType(id) {
      switch (id) {
        case 0: // 特殊，把新闻类型置为熱點
          return this.$t('home.hot');
        case 1:
          return this.$t('home.notice');
        case 2:
          return this.$t('home.preserve');
        case 3:
          return this.$t('home.news');
        case 4:
          return this.$t('home.active');
        case 5:
          return this.$t('home.declare');
        case 6:
          return this.$t('home.hot');
      }
    },
    showAllGames() {
      this.showMoreGame = false;
    },
    handleBanner() {
      this.is_show_banner &&
        this.$apis.home.getBanner().then(res => {
          if (res.data.code === 0) {
            this.bannerLists = res.data.data;
          }
        });
    },
    handleRecommend() {
      this.is_show_recommend &&
        this.$apis.home.getGameList().then(res => {
          if (res.data.code === 0) {
            this.topGameLists = res.data.data;
          } else {
            //   console.log(res.data.message);
          }
        });
    },
    handleNews() {
      this.is_show_news_notice &&
        Promise.all([
          this.$apis.home.getNewsTop(),
          this.$apis.home.getNewsList(1, 6)
        ]).then(res => {
          if (res[0].data.code === 0 && res[1].data.code === 0) {
            this.topNews = {};
            this.topNews.top_image_large =
              res[0].data.data.top_image_large || {};
            this.topNews.top_image_small_list =
              res[0].data.data.top_image_small_list || [];
            this.topNews.top_news_list = res[0].data.data.top_news_list || [];
            if (this.topNews.top_news_list.length > 0) {
              this.topNews.top_news_list.forEach(function (
                item,
                index,
                array
              ) {
                array[index].type = 6; // 强制把top_news_list的新闻转为type=6热点
              });
            }
            if (res[0].data.data.statement) {
              this.topNews.top_news_list.unshift(res[0].data.data.statement);
              this.topNews.top_news_list[0].type = 0; // 强制把statement的新闻转为type=0热点
            }
            let temp =
              6 - this.topNews.top_news_list.length > res[1].data.data.length
                ? res[1].data.data.length
                : 6 - this.topNews.top_news_list.length;
            for (let i = 0; i < temp; i++) {
              this.topNews["top_news_list"].push(res[1].data.data[i]);
            }
          } else {
            //   console.log("获取新闻数据失败~");
          }
        });
    },
    handleActivity() {
      this.is_show_activity &&
        this.$apis.home.getEventsList(1, 8).then(res => {
          if (res.data.code === 0) {
            this.topEvents = res.data.data;
          }
        });
    },
    onModuleRequestFailed() {
      this.is_show_banner = true
      this.is_show_recommend = true
      this.handleBanner()
      this.handleRecommend()
    }
  },
  created() {
    this.$apis.home
      .getModuleList()
      .then(res => {
        if (res.data.code == 0) {
          this.is_show_banner = res.data.data.is_show_banner;
          this.is_show_recommend = res.data.data.is_show_recommend;
          this.is_show_news_notice = res.data.data.is_show_news_notice;
          this.is_show_activity = res.data.data.is_show_activity;
          
          this.handleBanner()
          this.handleRecommend()
          this.handleNews()
          this.handleActivity()
        } else {
          // 接口请求失败时展示banner和推荐游戏
          this.onModuleRequestFailed()
        }
      })
      .catch(() => {
        // 接口请求失败时展示banner和推荐游戏
        this.onModuleRequestFailed()
      })
      .finally(() => {
        store.dispatch("setFooterStatus", true);
      });
  },
  mounted() { }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/css/swiper.min.css";
.home {
  padding-bottom: 60px;
  &.jp {
    .bui-btn {
      border-color: #ddd;
      &:hover {
        border-color: #50bbe5;
      }
    }
    .bui-title {
      &::after {
        height: 1px;
      }
    }
  }
  &.sea {
    .bui-title {
      font-weight: bold;
    }
  }
}
.banner {
  position: relative;
  width: 100%;
  /*height: 800px;*/
  padding-top: 41.667%;
  // .swiper-container {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   .swiper-slide {
  //     width: 100%;
  //     height: 100%;
  //     // background-image: url("../../assets/images/home/pic_default.svg");
  //     background-color: #eee;
  //     @extend %bgContain;
  //   }
  //   .swiper-button-prev,
  //   .swiper-button-next {
  //     top: auto;
  //     bottom: 30px;
  //     left: 50%;
  //     width: 30px;
  //     height: 30px;
  //     @extend %bgContain;
  //     background-color: rgba(0, 0, 0, 0.4);
  //     border-radius: 50%;
  //   }
  //   .swiper-button-prev {
  //     background-image: url("~@assetImages/home/swiper_left.svg");
  //     margin-left: -170px;
  //     &:hover {
  //       background-image: url("~@assetImages/home/swiper_left_hover.svg");
  //     }
  //   }
  //   .swiper-button-next {
  //     background-image: url("~@assetImages/home/swiper_right.svg");
  //     margin-left: 140px;
  //     &:hover {
  //       background-image: url("~@assetImages/home/swiper_right_hover.svg");
  //     }
  //   }
  //   .swiper-pagination.swiper-pagination-bullets {
  //     font-size: 0;
  //     bottom: 41px;
  //     /deep/ .swiper-pagination-bullet {
  //       background: rgba(255, 255, 255, 0.4);
  //       &.swiper-pagination-bullet-active {
  //         background: #fff;
  //       }
  //     }
  //   }
  // }
}

.bui-title {
  position: relative;
  margin: 60px auto 0;
  font-size: 24px;
  color: #444444;
  letter-spacing: 0;
  text-align: center;
  &::after {
    content: "";
    position: absolute;
    top: 34px;
    left: 50%;
    margin-left: -12px;
    background: #50bbe5;
    border-radius: 100px;
    width: 24px;
    height: 4px;
  }
}

.bui-title-little {
  margin: 24px auto 0;
  font-size: 12px;
  color: #cccccc;
  letter-spacing: 0;
  text-align: center;
}

.game-lists {
  margin: 30px auto 0;
  width: 1170px;
  ul {
    width: 100%;
    font-size: 0;
    li {
      position: relative;
      display: inline-block;
      vertical-align: top;
      margin-right: 30px;
      margin-bottom: 30px;
      width: 270px;
      // height: 215px;
      height: auto;
      .game-img {
        position: relative;
        top: 0;
        width: 100%;
        height: 152px;
        border-radius: 10px;
        transform: translateZ(0);
        background-image: url("~@assetImages/home/pic_default.svg");
        @extend %bgCover;
        transition: all 0.3s;
      }
      p {
        margin: 0;
        margin-top: 10px;
      }
      .game-name {
        font-size: 14px;
        color: #444444;
        letter-spacing: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 270px;
      }
      .game-description {
        height: 36px;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      a {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        text-decoration: none;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover {
        .game-img {
          // top: -4px;
          transform: translateY(-4px) translateY(0);
          box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
        }
        .game-name,
        .game-description {
          color: #50bbe5;
        }
      }
    }
  }
}

.bui-btn {
  display: block;
  text-decoration: none;
  margin: 60px auto 60px;
  width: 170px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #50bbe5;
  border-radius: 100px;
  text-align: center;
  font-size: 0;
  cursor: pointer;
  span {
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    margin-right: 10px;
    vertical-align: middle;
  }
  div {
    display: inline-block;
    background-image: url("~@assetImages/home/arrow_right_green.svg");
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }
  &:hover {
    background: #50bbe5;
    box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
    span {
      color: #ffffff;
    }
    div {
      background-image: url("~@assetImages/home/arrow_right_white.svg");
    }
  }
}

.news-notice {
  //   margin-top: 60px;
  width: 100%;
  height: 827px;
  border-top: 1px solid #eeeeee;
  .bui-title {
    margin-top: 90px;
  }
  .news-content {
    width: 1170px;
    height: 487px;
    margin: 30px auto 0;
    font-size: 0;
  }
  .news-left {
    position: relative;
    display: inline-block;
    width: 670px;
    height: 487px;
    vertical-align: top;
    a {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      // cursor: pointer;
    }
    .big-img {
      width: 670px;
      height: 377px;
      border-radius: 10px;
      background-image: url("~@assetImages/home/pic_default.svg");
      @extend %bgCover;
    }
    .title {
      position: relative;
      margin-top: 10px;
      width: 670px;
      height: 20px;
      .type {
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        width: 50px;
        height: 16px;
        line-height: 16px;
        background-color: #50bbe5;
        border-radius: 100px;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
      }
      strong {
        margin-left: 20px;
        display: inline-block;
        line-height: 20px;
        font-size: 20px;
        color: #333333;
        letter-spacing: 0;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 500px;
      }
      .time {
        position: absolute;
        right: 0;
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
      }
    }
    p {
      margin: 20px auto 0;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    &:hover {
      .big-img {
        box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
      }
      .title strong,
      p {
        color: #50bbe5;
      }
    }
  }
  .news-right {
    display: inline-block;
    width: 470px;
    height: 487px;
    margin-left: 30px;
    font-size: 0;
    .mini-news {
      position: relative;
      vertical-align: top;
      display: inline-block;
      width: 220px;
      height: 210px;
      font-size: 0;
      &:nth-child(2n) {
        margin-left: 30px;
      }
      div:nth-child(1) {
        width: 220px;
        height: 124px;
        border-radius: 10px;
        background-image: url("~@assetImages/home/pic_default.svg");
        @extend %bgCover;
      }
      p {
        margin: 10px auto 0;
        font-size: 14px;
        color: #444444;
        letter-spacing: 0;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 220px;
      }
      div:nth-child(3) {
        position: relative;
        height: 16px;
        margin-top: 20px;
        .type {
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          width: 50px;
          height: 16px;
          line-height: 16px;
          background-color: #50bbe5;
          border-radius: 100px;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0;
        }
        .time {
          position: absolute;
          right: 0;
          display: inline-block;
          vertical-align: middle;
          line-height: 20px;
          font-size: 12px;
          color: #999999;
          letter-spacing: 0;
        }
      }
      a {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        cursor: pointer;
      }
      &:hover {
        div:nth-child(1) {
          box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
        }
        p {
          color: #50bbe5;
        }
      }
    }
    .line {
      position: relative;
      width: 470px;
      height: 40px;
      font-size: 0;
      &:nth-child(3) {
        margin-top: 37px;
      }
      a {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        cursor: pointer;
      }
      .type {
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        width: 50px;
        height: 16px;
        line-height: 16px;
        background-color: #50bbe5;
        border-radius: 100px;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
      }
      .hot {
        background-color: #ffb13b;
      }
      .desc {
        margin-left: 20px;
        display: inline-block;
        line-height: 40px;
        vertical-align: middle;
        font-size: 14px;
        color: #444444;
        letter-spacing: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 380px;
      }
      .icon {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -6px;
        display: inline-block;
        background-image: url("~@assetImages/home/arrow_right_green.svg");
        width: 12px;
        height: 12px;
      }
      &:hover {
        .desc {
          color: #50bbe5;
        }
      }
    }
  }
}
.active {
  border-top: 1px solid #eeeeee;
}
.activity-container {
  margin: 0 auto;
  width: 1170px;
  .activity-line {
    position: relative;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #eeeeee;
    display: block;
    text-decoration: none;
    cursor: pointer;
    span {
      display: inline-block;
      vertical-align: middle;
      &:nth-child(1) {
        width: 130px;
        height: 20px;
        background: #50bbe5;
        border-radius: 100px;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
      }
      &:nth-child(2) {
        font-size: 14px;
        color: #444444;
        letter-spacing: 0;
        line-height: 60px;
        margin-left: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 900px;
      }
      &:nth-child(3) {
        background-image: url("~@assetImages/home/hot.svg");
        width: 14px;
        height: 16px;
        margin-left: 11px;
      }
      &:nth-child(4) {
        background-image: url("~@assetImages/home/arrow_right_green.svg");
        width: 12px;
        height: 12px;
        float: right;
        margin-top: 24px;
      }
    }
    a {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      text-decoration: none;
    }
    &:last-child {
      border-bottom: none;
    }
  }
  .activity-line:hover span:nth-child(2) {
    color: #50bbe5;
  }
}

.more-banner {
  position: relative;
  top: 65%;
  left: 50%;
  margin-left: 460px;
  background: #50bbe5;
  &:hover {
    box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
  }
  span {
    color: #ffffff;
  }
  div {
    background-image: url("~@assetImages/home/arrow_right_white.svg");
  }
}
</style>

